import { atomWithStorage } from 'jotai/utils'
import { atom } from 'jotai/vanilla'

import { STORAGE_KEY } from '@/constants/storages'
import { CHAIN_TYPE, ChainInfo } from '@/hooks/services/useChainInfo'
import { CommonTools } from '@/lib/CommonTools'

export const addressAtom = atom<string>()
export const isConnectedAtom = atom<boolean>(false)
export const tradeToolsAtom = atom<CommonTools>()

export const chainInfosAtom = atom<ChainInfo[]>([])

export const fromChainIdAtom = atomWithStorage<number | undefined>(STORAGE_KEY.FROM_CHAIN_ID, undefined, undefined, {
  getOnInit: true
})

export const fromChainTypeAtom = atomWithStorage<CHAIN_TYPE | undefined>(
  STORAGE_KEY.FROM_CHAIN_TYPE,
  undefined,
  undefined,
  {
    getOnInit: true
  }
)

export const toChainIdAtom = atom<number>()

export const writeChainInfosAtom = atom(null, (get, set, chainInfos: ChainInfo[]) => {
  set(chainInfosAtom, chainInfos)

  const fromChainId = get(fromChainIdAtom)
  const fromChainType = get(fromChainTypeAtom)

  const defaultChainInfo =
    chainInfos.find(
      ({ fromChain, toChains }) =>
        fromChain.type === fromChainType &&
        fromChain.id === fromChainId &&
        toChains.some(({ enableTrade }) => enableTrade)
    ) ||
    chainInfos.find(({ toChains }) => toChains.some(({ enableTrade }) => enableTrade)) ||
    chainInfos[0]

  console.log('>>>>>> defaultChainInfo: ', defaultChainInfo)

  if (defaultChainInfo) {
    set(fromChainIdAtom, defaultChainInfo.fromChain.id)
    set(fromChainTypeAtom, defaultChainInfo.fromChain.type)
    set(toChainIdAtom, defaultChainInfo.toChains.find(({ enableTrade }) => enableTrade)?.id)
  }
})

export const chainInfoAtom = atom((get) => {
  const chainInfos = get(chainInfosAtom)
  const fromChainId = get(fromChainIdAtom)

  return chainInfos.find(({ fromChain }) => fromChain.id === fromChainId)
})

export const fromChainAtom = atom((get) => get(chainInfoAtom)?.fromChain)

export const toChainAtom = atom((get) => {
  const chainInfo = get(chainInfoAtom)
  const toChainId = get(toChainIdAtom)

  return chainInfo?.toChains.find(({ id }) => id === toChainId)
})
